var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('v-chip',{attrs:{"small":"","color":_vm.getColor()}},[_vm._v(" "+_vm._s(_vm.model.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }